import { paperless, trusted, zeroMaintenance } from "../Helper/svgs";

const DematAdvantages = [
    {
        icon: paperless,
        title: 'Simple, Easy and Paperless work',
        content: 'Just fill your Details, Upload documents and Done',
    },
    {
        icon: trusted,
        title: 'Tested & Trusted Technology',
        content: 'Download app now',
    },
    {
        icon: zeroMaintenance,
        title: 'Zero Maintenance Fee',
        content: 'Zero Maintenance Fee for First Year',
    },
]

export default DematAdvantages;